import subjectsTableDirective from './subjectsTable.directive';

const subjectsTableModule = angular.module('app.components.clinicalData.subjects.subjectsTable', [])
	.directive('clinicalDataSubjectsTable', subjectsTableDirective)
	.name;

export default subjectsTableModule;
